(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('announcement-bar')) return;

    const MIN_INTERVAL_SECONDS = 3;

    class AnnouncementBar extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.slides = [...this.querySelectorAll('.announcement-bar__slide')];
        this.slidesContainer = this.querySelector('[data-announcement-slides]');
        this.index = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
        this.timer = null;
        this.isPaused = false;
        this.isStopped = false;

        this.querySelector('[data-announcement-previous]')?.addEventListener('click', () => this.step(-1, true), {
          signal,
        });
        this.querySelector('[data-announcement-next]')?.addEventListener('click', () => this.step(1, true), { signal });
        this.querySelector('[data-announcement-close]')?.addEventListener('click', () => this.dismiss(), { signal });

        ['mouseenter', 'focusin'].forEach((type) => this.addEventListener(type, () => this.pause(), { signal }));
        ['mouseleave', 'focusout'].forEach((type) =>
          this.addEventListener(type, (event) => !this.contains(event.relatedTarget) && this.resume(), { signal })
        );

        this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
        this.addEventListener('shopify:block:deselect', () => this.resume(), { signal });

        this.start();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        clearInterval(this.timer);
      }

      get canAutoplay() {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        return this.dataset.autoplay === 'true' && this.slides.length > 1 && !prefersReducedMotion && !this.isStopped;
      }

      start() {
        clearInterval(this.timer);
        if (!this.canAutoplay || this.isPaused) return;
        const seconds = Math.max(Number(this.dataset.interval) || 0, MIN_INTERVAL_SECONDS);
        this.timer = setInterval(() => this.step(1, false), seconds * 1000);
      }

      pause() {
        this.isPaused = true;
        clearInterval(this.timer);
      }

      resume() {
        this.isPaused = false;
        this.start();
      }

      step(direction, isUserAction) {
        if (isUserAction) {
          // Manual navigation stops autoplay for good (WCAG 2.2.2) and lets screen readers hear the change.
          this.isStopped = true;
          clearInterval(this.timer);
          this.slidesContainer?.setAttribute('aria-live', 'polite');
        }
        this.show((this.index + direction + this.slides.length) % this.slides.length);
      }

      show(index) {
        this.slides.forEach((slide, slideIndex) => (slide.hidden = slideIndex !== index));
        this.index = index;
      }

      onBlockSelect(event) {
        const index = this.slides.indexOf(event.target);
        if (index === -1) return;
        this.pause();
        this.show(index);
      }

      dismiss() {
        this.hidden = true;
        clearInterval(this.timer);
        try {
          sessionStorage.setItem(this.dataset.storageKey, 'true');
        } catch (error) {
          console.warn('Announcement dismissal could not be remembered', error);
        }
        document.querySelector('#MainContent')?.focus({ preventScroll: true });
      }
    }

    customElements.define('announcement-bar', AnnouncementBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    if (customElements.get('cart-drawer')) return;

    class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.dialog.addEventListener('click', this.onDialogClick);
        this.dialog.addEventListener('close', this.onClose);
        document.addEventListener('cart-drawer:open', this.open);
        document.addEventListener('cart-drawer:close', this.close);
        document.addEventListener('click', this.onTriggerClick);
        document.addEventListener('shopify:section:select', this.onEditorSelect);
        document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
      }

      disconnectedCallback() {
        document.removeEventListener('cart-drawer:open', this.open);
        document.removeEventListener('cart-drawer:close', this.close);
        document.removeEventListener('click', this.onTriggerClick);
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
      }

      open = () => {
        if (!this.dialog || this.dialog.open) return;
        const active = document.activeElement;
        this.returnFocus = active instanceof HTMLElement && active !== document.body ? active : null;
        this.dialog.showModal();
      };

      close = () => {
        if (this.dialog?.open) this.dialog.close();
      };

      onClose = () => {
        const target = this.returnFocus;
        this.returnFocus = null;
        if (target?.isConnected) target.focus();
      };

      onDialogClick = (event) => {
        if (event.target === this.dialog || event.target.closest('[data-cart-drawer-close]')) this.close();
      };

      onTriggerClick = (event) => {
        const trigger = event.target.closest('[data-cart-drawer-trigger]');
        if (!trigger || event.defaultPrevented) return;
        event.preventDefault();
        this.open();
      };

      onEditorSelect = (event) => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.open();
      };

      onEditorDeselect = (event) => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.close();
      };
    }

    customElements.define('cart-drawer', CartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-notification"]) return;
  try {
    
  (() => {
    if (customElements.get('cart-notification')) return;

    const DEFAULT_DISMISS_MS = 5000;
    const MAX_ITEMS = 3;
    const IMAGE_WIDTH = 160;

    const sizedImage = (url) => {
      if (!url) return '';
      const [base, query] = url.split('?');
      const params = new URLSearchParams(query || '');
      params.set('width', String(IMAGE_WIDTH));
      return `${base}?${params}`;
    };

    const fill = (template, key, value) => template.split(`[${key}]`).join(value);

    class CartNotification extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-cart-notification-panel]');
        this.template = this.querySelector('template[data-cart-notification-item]');
        if (!this.panel || !this.template) return;
        this.duration = Number(this.dataset.autoDismissMs) || DEFAULT_DISMISS_MS;
        this.panel.style.setProperty('--cart-notification-duration', `${this.duration}ms`);

        document.addEventListener('cart-notification:open', this.onOpen);
        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('pointerdown', this.onPointerDown);
        document.addEventListener('shopify:section:select', this.onEditorSelect);
        document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
        this.panel.addEventListener('click', this.onPanelClick);
        this.panel.addEventListener('pointerenter', this.pause);
        this.panel.addEventListener('pointerleave', this.onPointerLeave);
        this.panel.addEventListener('focusin', this.pause);
        this.panel.addEventListener('focusout', this.onFocusOut);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('cart-notification:open', this.onOpen);
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('pointerdown', this.onPointerDown);
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
      }

      get isOpen() {
        return this.panel?.hasAttribute('data-open');
      }

      onOpen = (event) => {
        const items = (event.detail?.items || []).filter(Boolean);
        if (!items.length) return;
        this.render(items, event.detail?.cart);
        this.open();
      };

      render(items, cart) {
        const list = this.querySelector('[data-cart-notification-items]');
        list.replaceChildren(...items.slice(0, MAX_ITEMS).map((item) => this.renderItem(item)));

        const subtotal = this.querySelector('[data-cart-notification-subtotal]');
        const total = cart?.total_price ?? items.reduce((sum, item) => sum + (item.final_line_price || 0), 0);
        subtotal.textContent = window.theme.formatMoney(total);

        if (cart) this.renderShipping(cart.total_price);
      }

      renderItem(item) {
        const node = this.template.content.firstElementChild.cloneNode(true);
        const imageUrl = item.featured_image?.url || item.image;
        const image = node.querySelector('[data-item-image]');
        if (imageUrl) image.src = sizedImage(imageUrl);
        node.querySelectorAll('[data-item-link]').forEach((link) => {
          link.href = item.url || window.theme.routes.cart;
        });
        node.querySelector('[data-item-title]').textContent = item.product_title || item.title || '';

        const variant = node.querySelector('[data-item-variant]');
        const variantText = item.product_has_only_default_variant ? '' : item.variant_title || '';
        variant.textContent = variantText;
        variant.hidden = !variantText;

        const quantity = this.dataset.quantityLabel || '';
        node.querySelector('[data-item-quantity]').textContent = fill(quantity, 'quantity', String(item.quantity || 1));

        const price = node.querySelector('[data-item-price]');
        const current = item.final_price ?? item.price ?? 0;
        const compare = Math.max(item.original_price || 0, item.variant?.compare_at_price || 0);
        if (compare > current) {
          price.classList.add('price--on-sale');
          price.append(this.priceNode('s', 'price__compare', compare, this.dataset.regularPrice));
        }
        price.append(this.priceNode('span', 'price__current', current, compare > current ? this.dataset.salePrice : ''));
        return node;
      }

      priceNode(tag, className, cents, label) {
        const fragment = document.createDocumentFragment();
        if (label) {
          const hidden = document.createElement('span');
          hidden.className = 'visually-hidden';
          hidden.textContent = label;
          fragment.append(hidden);
        }
        const element = document.createElement(tag);
        element.className = className;
        element.textContent = window.theme.formatMoney(cents);
        fragment.append(element);
        return fragment;
      }

      renderShipping(totalCents) {
        const wrapper = this.querySelector('[data-free-shipping]');
        const threshold = Number(wrapper?.dataset.threshold);
        if (!wrapper || !threshold) return;
        const remaining = threshold - totalCents;
        const progress = Math.min(100, Math.floor((totalCents * 100) / threshold));
        const isUnlocked = remaining <= 0;

        wrapper.classList.toggle('cart-free-shipping--unlocked', isUnlocked);
        wrapper.querySelector('[data-free-shipping-text]').textContent = isUnlocked
          ? this.dataset.shippingUnlocked
          : fill(this.dataset.shippingRemaining || '', 'amount', window.theme.formatMoney(remaining));
        wrapper.querySelector('[data-free-shipping-track]')?.setAttribute('aria-valuenow', String(progress));
        wrapper.querySelector('[data-free-shipping-bar]')?.style.setProperty('--cart-free-shipping-progress', `${progress}%`);
      }

      open() {
        const active = document.activeElement;
        const isKeyboard = active instanceof HTMLElement && active !== document.body && active.matches(':focus-visible');
        if (!this.panel.contains(active)) {
          this.returnFocus = active instanceof HTMLElement && active !== document.body ? active : null;
        }

        this.panel.inert = false;
        if (this.isOpen) {
          this.panel.removeAttribute('data-open');
          void this.panel.offsetWidth;
        }
        this.panel.setAttribute('data-open', '');
        this.announce();

        if (isKeyboard) this.querySelector('[data-cart-notification-heading]')?.focus();
        this.startTimer(this.duration);
      }

      close({ restoreFocus = false } = {}) {
        if (!this.isOpen) return;
        clearTimeout(this.timer);
        const hadFocus = this.panel.contains(document.activeElement);
        this.panel.removeAttribute('data-open');
        this.panel.removeAttribute('data-counting');
        this.panel.removeAttribute('data-paused');
        this.panel.inert = true;
        const target = this.returnFocus;
        this.returnFocus = null;
        if ((hadFocus || restoreFocus) && target?.isConnected) target.focus();
      }

      announce() {
        const status = this.querySelector('[data-cart-notification-status]');
        const titles = Array.from(this.querySelectorAll('[data-item-title]'), (el) => el.textContent).join(', ');
        if (!status || !titles) return;
        status.textContent = '';
        requestAnimationFrame(() => {
          status.textContent = fill(this.dataset.announcement || '', 'title', titles);
        });
      }

      startTimer(ms) {
        clearTimeout(this.timer);
        this.remaining = ms;
        this.startedAt = Date.now();
        this.panel.removeAttribute('data-paused');
        this.panel.removeAttribute('data-counting');
        void this.panel.offsetWidth;
        this.panel.setAttribute('data-counting', '');
        if (this.panel.matches(':hover') || this.panel.contains(document.activeElement)) this.pause();
        else this.timer = setTimeout(() => this.close(), ms);
      }

      pause = () => {
        if (!this.isOpen || this.panel.hasAttribute('data-paused')) return;
        clearTimeout(this.timer);
        this.remaining = Math.max(0, this.remaining - (Date.now() - this.startedAt));
        this.panel.setAttribute('data-paused', '');
      };

      resume = () => {
        if (!this.isOpen || !this.panel.hasAttribute('data-paused')) return;
        this.panel.removeAttribute('data-paused');
        this.startedAt = Date.now();
        this.timer = setTimeout(() => this.close(), this.remaining);
      };

      onPointerLeave = () => {
        if (!this.panel.contains(document.activeElement)) this.resume();
      };

      onFocusOut = (event) => {
        if (!this.panel.contains(event.relatedTarget) && !this.panel.matches(':hover')) this.resume();
      };

      onPanelClick = (event) => {
        if (event.target.closest('[data-cart-notification-close]')) this.close({ restoreFocus: true });
      };

      onKeydown = (event) => {
        if (event.key === 'Escape' && this.isOpen) this.close({ restoreFocus: true });
      };

      onPointerDown = (event) => {
        if (this.isOpen && !this.panel.contains(event.target)) this.close();
      };

      onEditorSelect = async (event) => {
        if (event.detail?.sectionId !== this.dataset.sectionId || !window.theme?.cart) return;
        try {
          const cart = await window.theme.cart.get();
          if (!cart.items?.length) return;
          this.render(cart.items.slice(0, 1), cart);
          this.open();
          clearTimeout(this.timer);
          this.panel.removeAttribute('data-counting');
        } catch {}
      };

      onEditorDeselect = (event) => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.close();
      };
    }

    customElements.define('cart-notification', CartNotification);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('footer-accordion')) {
    customElements.define(
      'footer-accordion',
      class FooterAccordion extends HTMLElement {
        static DESKTOP_QUERY = '(min-width: 990px)';

        connectedCallback() {
          this.details = this.querySelector('details');
          this.summary = this.querySelector('summary');
          if (!this.details || !this.summary) return;

          this.mediaQuery = window.matchMedia(FooterAccordion.DESKTOP_QUERY);
          this.mediaQuery.addEventListener('change', this.sync);
          this.summary.addEventListener('click', this.onSummaryClick);
          this.sync();
        }

        disconnectedCallback() {
          this.mediaQuery?.removeEventListener('change', this.sync);
          this.summary?.removeEventListener('click', this.onSummaryClick);
        }

        sync = () => {
          const isDesktop = this.mediaQuery.matches;
          this.details.open = isDesktop;
          if (isDesktop) this.summary.setAttribute('tabindex', '-1');
          else this.summary.removeAttribute('tabindex');
        };

        onSummaryClick = (event) => {
          if (this.mediaQuery.matches) event.preventDefault();
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('header-component')) return;

    const SCROLLED_OFFSET = 50;
    const HIDE_OFFSET = 100;
    // theme.js is deferred after this bundle, so window.theme helpers can be missing at connect time.
    const whenThemeReady = (callback) => {
      if (window.theme?.wishlist) return callback();
      if (document.readyState !== 'loading') return;
      document.addEventListener('DOMContentLoaded', () => window.theme?.wishlist && callback(), { once: true });
    };

    class HeaderComponent extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.drawer = this.querySelector('[data-header-drawer]');
        this.search = this.querySelector('[data-header-search]');
        this.lastScrollY = Math.max(window.scrollY, 0);
        this.scrollFrame = null;

        window.addEventListener('scroll', () => this.requestScrollUpdate(), { passive: true, signal });
        this.updateScrollState();

        this.resizeObserver = new ResizeObserver(() => this.publishHeight());
        this.resizeObserver.observe(this);

        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('focusin', () => this.removeAttribute('data-hidden'), { signal });

        if (this.drawer) {
          this.drawer.addEventListener(
            'close',
            () => {
              this.setExpanded('[data-drawer-open]', false);
              this.showMenuPanel(this.drawer.querySelector('[data-menu-panel]'));
            },
            { signal }
          );
          this.drawer.addEventListener('click', (event) => event.target === this.drawer && this.drawer.close(), { signal });
        }

        document.addEventListener('cart:updated', (event) => this.updateCount('cart', event.detail?.cart?.item_count), {
          signal,
        });
        document.addEventListener(
          'wishlist:updated',
          (event) => this.updateCount('wishlist', event.detail?.handles?.length),
          { signal }
        );
        whenThemeReady(() => this.updateCount('wishlist', window.theme.wishlist.all().length));
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      publishHeight() {
        document.documentElement.style.setProperty('--header-height', `${Math.round(this.offsetHeight)}px`);
      }

      requestScrollUpdate() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateScrollState();
        });
      }

      updateScrollState() {
        const scrollY = Math.max(window.scrollY, 0);
        this.toggleAttribute('data-scrolled', scrollY > SCROLLED_OFFSET);

        if (this.dataset.sticky === 'scroll-up') {
          const isBusy = Boolean(this.querySelector('details[open]') || this.drawer?.open || this.search?.open);
          const isScrollingDown = scrollY > this.lastScrollY;
          if (isBusy || scrollY <= HIDE_OFFSET || !isScrollingDown) this.removeAttribute('data-hidden');
          else this.setAttribute('data-hidden', '');
        }

        this.lastScrollY = scrollY;
      }

      onClick(event) {
        const trigger = event.target.closest(
          '[data-drawer-open], [data-drawer-close], [data-menu-open], [data-menu-back], [data-search-open], [data-search-close], [data-cart-link]'
        );

        if (!trigger) {
          if (this.drawer?.open && event.target.closest('a[href]')) this.drawer.close();
          return;
        }

        if (trigger.matches('[data-drawer-open]')) return this.openDialog(this.drawer, trigger);
        if (trigger.matches('[data-drawer-close]')) return this.drawer?.close();
        if (trigger.matches('[data-menu-open]')) return this.openMenuPanel(trigger);
        if (trigger.matches('[data-menu-back]')) return this.closeMenuPanel(trigger);
        if (trigger.matches('[data-search-open]')) {
          event.preventDefault();
          if (this.drawer?.open) this.drawer.close();
          return this.openDialog(this.search, trigger);
        }
        if (trigger.matches('[data-search-close]')) return this.search?.close();
        if (trigger.matches('[data-cart-link]')) this.onCartClick(event);
      }

      openDialog(dialog, trigger) {
        if (!dialog || dialog.open) return;
        dialog.showModal();
        if (trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'true');
        dialog.querySelector('[data-initial-focus]')?.focus();
      }

      openMenuPanel(trigger) {
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!panel) return;
        trigger.setAttribute('aria-expanded', 'true');
        this.showMenuPanel(panel);
        panel.querySelector('[data-menu-back]')?.focus();
      }

      closeMenuPanel(trigger) {
        const panel = trigger.closest('[data-menu-panel]');
        const parent = document.getElementById(panel.dataset.parent) ?? this.drawer.querySelector('[data-menu-panel]');
        const opener = parent.querySelector(`[aria-controls="${panel.id}"]`);
        opener?.setAttribute('aria-expanded', 'false');
        this.showMenuPanel(parent);
        opener?.focus();
      }

      showMenuPanel(panel) {
        if (!panel) return;
        this.drawer.querySelectorAll('[data-menu-panel]').forEach((element) => (element.hidden = element !== panel));
        this.drawer.querySelector('.header-drawer__nav').scrollTop = 0;
      }

      setExpanded(selector, isExpanded) {
        this.querySelectorAll(selector).forEach((element) => element.setAttribute('aria-expanded', String(isExpanded)));
      }

      onCartClick(event) {
        if (window.theme?.cartType !== 'drawer' || typeof window.theme.emit !== 'function') return;
        event.preventDefault();
        window.theme.emit('cart-drawer:open');
      }

      updateCount(type, count) {
        if (typeof count !== 'number') return;
        this.querySelectorAll(`[data-count="${type}"]`).forEach((link) => {
          const badge = link.querySelector('[data-count-badge]');
          const label = link.querySelector('[data-count-label]');
          if (badge) {
            badge.textContent = String(count);
            badge.hidden = count === 0;
          }
          if (label) {
            const template = count === 1 ? label.dataset.one : label.dataset.other;
            label.textContent = (template || '').replace('[count]', String(count));
          }
        });
      }
    }

    customElements.define('header-component', HeaderComponent);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    const ACTIVE_SLIDE_RATIO = 0.6;
    const MOBILE_VIDEO_QUERY = '(max-width: 749px)';

    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slideshow-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-slideshow-dot]')];
        this.pauseButton = this.querySelector('[data-slideshow-pause]');
        this.index = 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.pageLoaded = document.readyState === 'complete';
        if (!this.pageLoaded) {
          this.onPageLoad = () => {
            this.pageLoaded = true;
            this.syncVideos();
          };
          window.addEventListener('load', this.onPageLoad, { once: true });
        }
        if (!this.track || this.slides.length < 2) {
          this.syncVideos();
          return;
        }

        this.speed = Number(this.dataset.speed) || 5000;
        this.autoplay = this.dataset.autoplay === 'true';
        this.userPaused = !this.autoplay || this.reducedMotion.matches;
        this.interactionPaused = false;
        this.inView = true;

        this.slideObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= ACTIVE_SLIDE_RATIO) {
                this.setActive(this.slides.indexOf(entry.target));
              }
            });
          },
          { root: this.track, threshold: ACTIVE_SLIDE_RATIO }
        );
        this.slides.forEach((slide) => this.slideObserver.observe(slide));

        this.viewObserver = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.schedule();
        });
        this.viewObserver.observe(this);

        this.querySelector('[data-slideshow-prev]')?.addEventListener('click', () => this.goTo(this.index - 1));
        this.querySelector('[data-slideshow-next]')?.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slideshowDot))));
        this.pauseButton?.addEventListener('click', () => this.togglePause());

        this.addEventListener('mouseenter', () => this.setInteractionPaused(true));
        this.addEventListener('mouseleave', () => this.setInteractionPaused(this.contains(document.activeElement)));
        this.addEventListener('focusin', () => this.setInteractionPaused(true));
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.setInteractionPaused(this.matches(':hover'));
        });
        this.addEventListener('keydown', (event) => this.onKeydown(event));

        this.onVisibilityChange = () => this.schedule();
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        this.onBlockSelect = (event) => {
          const slide = this.slides.find((item) => item.dataset.blockId === event.detail.blockId);
          if (!slide) return;
          this.editorPaused = true;
          this.goTo(this.slides.indexOf(slide), { instant: true });
        };
        this.onBlockDeselect = () => {
          this.editorPaused = false;
          this.schedule();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.setActive(0, { force: true });
        this.syncPauseButton();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.onPageLoad) window.removeEventListener('load', this.onPageLoad);
        this.slideObserver?.disconnect();
        this.viewObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      get shouldPlay() {
        return (
          this.autoplay &&
          !this.userPaused &&
          !this.interactionPaused &&
          !this.editorPaused &&
          this.inView &&
          !document.hidden
        );
      }

      goTo(index, { instant = false } = {}) {
        const count = this.slides.length;
        const target = ((index % count) + count) % count;
        const behavior = instant || this.reducedMotion.matches ? 'auto' : 'smooth';
        this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior });
        this.setActive(target);
      }

      setActive(index, { force = false } = {}) {
        if (index < 0 || (index === this.index && !force)) return;
        this.index = index;
        this.slides.forEach((slide, i) => {
          slide.inert = i !== index;
        });
        this.syncVideos();
        this.dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.schedule();
      }

      get videosAllowed() {
        if (!this.pageLoaded || this.reducedMotion.matches) return false;
        const conn = navigator.connection;
        if (conn?.saveData) return false;
        // Skip the hero video on slow connections: a stalling video is worse than a still poster.
        if (conn?.effectiveType && /(^|-)(2g|slow-2g)$/.test(conn.effectiveType)) return false;
        // Shopify does not always generate a smaller rendition. When the mobile source is the same
        // file as the desktop one, playing it on a phone means downloading a full 1080p clip over
        // mobile data for a decorative background — the poster image alone is the better trade.
        if (window.matchMedia(MOBILE_VIDEO_QUERY).matches && !this.allowMobileVideo) {
          const sameSource = this.slides.some((slide) => {
            const v = slide.querySelector('video[data-hero-video]');
            return v && v.dataset.srcSmall && v.dataset.srcSmall === v.dataset.srcLarge;
          });
          if (sameSource) return false;
        }
        return true;
      }

      get allowMobileVideo() {
        return this.dataset.mobileVideo === 'true';
      }

      loadVideo(video) {
        if (video.dataset.loaded) return;
        const isMobile = window.matchMedia(MOBILE_VIDEO_QUERY).matches;
        const src = isMobile ? video.dataset.srcSmall : video.dataset.srcLarge;
        if (!src) return;
        video.dataset.loaded = 'true';
        video.muted = true;
        video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
        video.preload = 'auto';
        video.src = src;
        video.load();
      }

      syncVideos() {
        const canPlay = this.videosAllowed;
        this.slides.forEach((slide, i) => {
          const video = slide.querySelector('video[data-hero-video]');
          if (!video) return;
          if (i === this.index && canPlay) {
            this.loadVideo(video);
            if (video.dataset.loaded) video.play().catch(() => {});
          } else if (video.dataset.loaded) {
            video.pause();
          }
        });
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.shouldPlay) return;
        this.timer = setTimeout(() => this.goTo(this.index + 1), this.speed);
      }

      setInteractionPaused(paused) {
        this.interactionPaused = paused;
        this.schedule();
      }

      togglePause() {
        this.userPaused = !this.userPaused;
        this.syncPauseButton();
        this.schedule();
      }

      syncPauseButton() {
        this.dataset.paused = String(this.userPaused);
        this.track.setAttribute('aria-live', this.userPaused || !this.autoplay ? 'polite' : 'off');
        if (!this.pauseButton) return;
        const { labelPause, labelPlay } = this.pauseButton.dataset;
        this.pauseButton.setAttribute('aria-label', this.userPaused ? labelPlay : labelPause);
      }

      onKeydown(event) {
        if (!event.target.closest('[data-slideshow-dot], [data-slideshow-prev], [data-slideshow-next]')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        const activeDot = this.dots[this.index];
        if (activeDot && event.target.matches('[data-slideshow-dot]')) activeDot.focus();
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (() => {
    const matchOption = (select, value) => {
      if (!value) return false;
      const needle = value.trim().toLowerCase();
      const option = Array.from(select.options).find(
        (candidate) => candidate.value.toLowerCase() === needle || candidate.textContent.trim().toLowerCase() === needle
      );
      if (option) select.value = option.value;
      return Boolean(option);
    };

    const parseProvinces = (option) => {
      try {
        const provinces = JSON.parse(option?.dataset.provinces || '[]');
        return Array.isArray(provinces) ? provinces : [];
      } catch {
        return [];
      }
    };

    if (!customElements.get('country-province-select')) {
      class CountryProvinceSelect extends HTMLElement {
        connectedCallback() {
          this.country = this.querySelector('[data-country-select]');
          this.province = this.querySelector('[data-province-select]');
          this.provinceField = this.querySelector('[data-province-field]');
          if (!this.country || !this.province) return;
          matchOption(this.country, this.country.dataset.default);
          this.renderProvinces(this.province.dataset.default);
          this.country.addEventListener('change', () => this.renderProvinces());
        }

        renderProvinces(selected) {
          const provinces = parseProvinces(this.country.selectedOptions[0]);
          this.province.replaceChildren(
            ...provinces.map(([value, label]) => new Option(label ?? value, value))
          );
          const hasProvinces = provinces.length > 0;
          this.province.disabled = !hasProvinces;
          if (this.provinceField) this.provinceField.hidden = !hasProvinces;
          if (hasProvinces) matchOption(this.province, selected);
        }
      }

      customElements.define('country-province-select', CountryProvinceSelect);
    }

    if (!customElements.get('customer-addresses')) {
      class CustomerAddresses extends HTMLElement {
        connectedCallback() {
          this.addEventListener('submit', this.onSubmit);
        }

        onSubmit = (event) => {
          if (!event.target.matches('[data-address-delete]')) return;
          const message = this.dataset.confirmMessage;
          if (message && !window.confirm(message)) event.preventDefault();
        };
      }

      customElements.define('customer-addresses', CustomerAddresses);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    if (customElements.get('cart-sticky-checkout')) return;

    class CartStickyCheckout extends HTMLElement {
      connectedCallback() {
        const target = this.closest('cart-region')?.querySelector('[data-cart-summary-actions]');
        if (!target || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(([entry]) => {
          this.toggleAttribute('data-hidden', entry.isIntersecting || entry.boundingClientRect.top < 0);
        });
        this.observer.observe(target);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }

    customElements.define('cart-sticky-checkout', CartStickyCheckout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  class CollectionList extends HTMLElement {
    static COLUMNS_KEY = 'hayora:collections-columns';
    static COLUMN_OPTIONS = ['2', '3', '4'];

    connectedCallback() {
      this.grid = this.querySelector('[data-collection-grid]');
      this.sortButton = this.querySelector('[data-list-sort]');
      this.isNewestFirst = false;

      const views = this.querySelector('[data-list-views]');
      if (views) views.hidden = false;
      if (this.sortButton) this.sortButton.hidden = false;

      this.applyColumns(this.readColumns());
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    readColumns() {
      try {
        const stored = localStorage.getItem(CollectionList.COLUMNS_KEY);
        if (CollectionList.COLUMN_OPTIONS.includes(stored)) return stored;
      } catch {}
      return this.dataset.columns;
    }

    applyColumns(columns) {
      this.dataset.columns = columns;
      this.querySelectorAll('[data-list-columns]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.listColumns === columns));
      });
    }

    toggleSort() {
      if (!this.grid || !this.sortButton) return;
      this.isNewestFirst = !this.isNewestFirst;
      const items = [...this.grid.querySelectorAll('[data-collection-item]')];
      items.sort((a, b) => Number(a.dataset.order) - Number(b.dataset.order));
      if (this.isNewestFirst) items.reverse();
      this.grid.append(...items);
      const label = this.sortButton.querySelector('[data-list-sort-label]');
      if (label) {
        label.textContent = this.isNewestFirst ? this.sortButton.dataset.labelNewest : this.sortButton.dataset.labelFeatured;
      }
    }

    onClick = (event) => {
      const columnButton = event.target.closest('[data-list-columns]');
      if (columnButton) {
        const columns = columnButton.dataset.listColumns;
        try {
          localStorage.setItem(CollectionList.COLUMNS_KEY, columns);
        } catch {}
        this.applyColumns(columns);
        return;
      }
      if (event.target.closest('[data-list-sort]')) this.toggleSort();
    };
  }

  if (!customElements.get('collection-list')) customElements.define('collection-list', CollectionList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.addEventListener('change', (event) => this.onChange(event), { signal });
      this.addEventListener('submit', (event) => this.onSubmit(event), { signal });
      this.addEventListener('click', (event) => this.onClick(event), { signal });
      this.addEventListener('product:notify', (event) => this.openNotify(event.detail), { signal });
      this.observeStickyBar();
      this.picker?.refresh?.();
      if (this.querySelector('[data-notify-form] [data-notify-posted]')) this.openNotifySuccess();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.fetchController?.abort();
      this.stickyObserver?.disconnect();
      clearTimeout(this.addedTimer);
    }

    get strings() {
      return window.theme?.strings || {};
    }

    get picker() {
      return this.querySelector('variant-picker');
    }

    get scrollBehavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    setPending(isPending) {
      this.toggleAttribute('data-pending', isPending);
      this.querySelectorAll('[data-add-button]').forEach((button) => {
        button.disabled = isPending;
      });
    }

    onChange(event) {
      if (event.target.matches('[data-option-value-id]')) this.changeVariant(event.target);
    }

    onSubmit(event) {
      const form = event.target;
      if (form.matches('[data-product-form]')) {
        event.preventDefault();
        if (this.hasAttribute('data-pending')) return this.picker?.warnFirstMissing();
        this.addToCart(form, event.submitter);
      } else if (form.matches('[data-notify-form]')) {
        event.preventDefault();
        this.submitNotify(form);
      }
    }

    onClick(event) {
      const step = event.target.closest('[data-quantity-step]');
      if (step) return this.stepQuantity(step);

      const notifyOpener = event.target.closest('[data-notify-open]');
      if (notifyOpener) {
        return this.openNotify({ id: notifyOpener.dataset.variantId, title: notifyOpener.dataset.variantTitle });
      }

      const opener = event.target.closest('[data-dialog-open]');
      if (opener) {
        const dialog = document.getElementById(opener.dataset.dialogOpen);
        if (!dialog) return;
        event.preventDefault();
        dialog.showModal();
        return;
      }

      if (event.target.closest('[data-dialog-close]')) {
        event.target.closest('dialog')?.close();
        return;
      }

      if (event.target instanceof HTMLDialogElement && !event.target.matches('[data-zoom-dialog]')) {
        event.target.close();
        return;
      }

      if (event.target.closest('[data-sticky-add]')) {
        if (this.hasAttribute('data-pending')) {
          this.picker?.scrollIntoView({ behavior: this.scrollBehavior, block: 'center' });
          this.picker?.warnFirstMissing();
          return;
        }
        const form = this.querySelector('[data-product-form]');
        form?.requestSubmit(form.querySelector('[data-add-button]'));
      }
    }

    stepQuantity(button) {
      const input = button.closest('[data-quantity]')?.querySelector('input');
      if (!input || input.disabled) return;
      const previous = input.value;
      if (Number(button.dataset.quantityStep) > 0) input.stepUp();
      else input.stepDown();
      if (input.value !== previous) input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    async changeVariant(input) {
      const optionValueIds = [...this.querySelectorAll('[data-variant-picker] [data-option]')]
        .map((fieldset) => fieldset.querySelector('.variant-picker__input:checked')?.dataset.optionValueId)
        .filter(Boolean);
      const focusedValueId = input.dataset.optionValueId;

      this.fetchController?.abort();
      this.fetchController = new AbortController();
      this.setAttribute('aria-busy', 'true');

      try {
        const params = new URLSearchParams({ option_values: optionValueIds.join(','), section_id: this.dataset.section });
        const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.fetchController.signal });
        if (!response.ok) throw new Error(this.strings.error);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.querySelector('product-info');
        if (!next) throw new Error(this.strings.error);
        this.render(html, next, focusedValueId);
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.theme?.toast?.(this.strings.error);
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    render(html, next, focusedValueId) {
      const quantities = new Map(
        [...this.querySelectorAll('[data-quantity] input')].map((input) => [input.id, input.value])
      );

      this.querySelectorAll('[data-product-update]').forEach((region) => {
        const replacement = html.getElementById(region.id);
        if (replacement) region.innerHTML = replacement.innerHTML;
      });

      quantities.forEach((value, id) => {
        const input = document.getElementById(id);
        if (!input || input.disabled) return;
        const min = Number(input.min || 1);
        const max = input.max ? Number(input.max) : Infinity;
        if (Number(value) >= min && Number(value) <= max) input.value = value;
      });

      this.dataset.variantId = next.dataset.variantId;
      const picker = this.picker;
      picker?.refresh();
      if (!picker) this.setPending(false);

      if (focusedValueId) {
        const input = this.querySelector(`[data-option-value-id="${CSS.escape(focusedValueId)}"]`);
        const menu = input?.closest('[data-dropdown-menu]');
        const fieldset = menu?.closest('[data-option]');
        const target = fieldset
          ? [fieldset.querySelector('[data-native-option]'), fieldset.querySelector('[data-dropdown-trigger]')].find(
              (control) => control?.getClientRects().length
            )
          : input;
        target?.focus({ preventScroll: true });
      }

      if (next.dataset.featuredMediaId) {
        this.querySelector('product-gallery')?.showMedia(next.dataset.featuredMediaId);
      }

      if (this.dataset.updateUrl !== 'false' && next.dataset.variantId && !picker?.isPending) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', next.dataset.variantId);
        window.history.replaceState(window.history.state, '', url);
      }

      const status = this.querySelector('[data-variant-status]');
      if (status) status.textContent = next.dataset.announcement || '';

      window.Shopify?.PaymentButton?.init?.();
      window.theme?.emit?.('product:variant-changed', { variantId: next.dataset.variantId, sectionId: this.dataset.section });
    }

    async addToCart(form, submitter) {
      const button = submitter || form.querySelector('[data-add-button]');
      const errorElement = form.querySelector('[data-form-error]');
      if (!window.theme?.cart) {
        form.submit();
        return;
      }

      const data = new FormData(form);
      const item = { id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) };
      if (data.get('selling_plan')) item.selling_plan = Number(data.get('selling_plan'));

      const properties = {};
      for (const [key, value] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      }
      if (Object.keys(properties).length) item.properties = properties;

      if (errorElement) {
        errorElement.hidden = true;
        errorElement.textContent = '';
      }
      button?.setAttribute('aria-busy', 'true');

      try {
        await window.theme.cart.add(item);
        this.showAdded(button);
      } catch (error) {
        if (errorElement) {
          errorElement.textContent = error.message || this.strings.error;
          errorElement.hidden = false;
        }
      } finally {
        button?.removeAttribute('aria-busy');
      }
    }

    showAdded(button) {
      if (!button) return;
      clearTimeout(this.addedTimer);
      button.toggleAttribute('data-added', true);
      this.addedTimer = setTimeout(() => button.removeAttribute('data-added'), 2000);
    }

    openNotify(variant) {
      const dialog = this.querySelector('[data-notify-dialog]');
      const form = dialog?.querySelector('[data-notify-form]');
      if (!dialog || !form) return;

      if (variant?.id) {
        const isSingle = dialog.dataset.singleVariant === 'true';
        const item = isSingle ? dialog.dataset.productTitle : `${dialog.dataset.productTitle} – ${variant.title}`;
        const url = `${dialog.dataset.productUrl}?variant=${variant.id}`;
        const fields = {
          variant: variant.title,
          variant_id: String(variant.id),
          url,
          body: `Back in stock request: ${item} (variant ${variant.id}) ${url}`,
        };
        Object.entries(fields).forEach(([name, value]) => {
          const field = form.querySelector(`[data-notify-field="${name}"]`);
          if (field) field.value = value;
        });
        dialog.querySelectorAll('[data-notify-item]').forEach((element) => {
          element.textContent = item;
        });
      }

      form.querySelector('[data-notify-error]')?.setAttribute('hidden', '');
      form.querySelector('[data-notify-errors]')?.remove();
      dialog.showModal();
      form.querySelector('input[type="email"]')?.focus();
    }

    openNotifySuccess() {
      this.querySelector('[data-notify-success]')?.showModal();
    }

    async submitNotify(form) {
      const button = form.querySelector('[type="submit"]');
      const errorElement = form.querySelector('[data-notify-error]');
      if (errorElement) errorElement.hidden = true;
      button?.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(form.action, { method: 'POST', body: new FormData(form) });
        if (response.url.includes('/challenge')) {
          form.submit();
          return;
        }
        if (!response.ok) throw new Error(this.strings.error);

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = html.getElementById(form.id);
        if (replacement?.querySelector('[data-notify-posted]')) {
          form.closest('dialog')?.close();
          form.querySelectorAll('input[type="email"], input[autocomplete="name"]').forEach((input) => {
            input.value = '';
          });
          this.openNotifySuccess();
          return;
        }

        const errors = replacement?.querySelector('[data-notify-errors]');
        throw new Error(errors?.textContent.trim() || this.strings.error);
      } catch (error) {
        if (errorElement) {
          errorElement.textContent = error.message || this.strings.error;
          errorElement.hidden = false;
        }
      } finally {
        button?.removeAttribute('aria-busy');
      }
    }

    observeStickyBar() {
      const bar = this.querySelector('[data-sticky-bar]');
      const target = this.querySelector('[data-buy-buttons]');
      if (!bar || !target) return;

      this.stickyObserver = new IntersectionObserver(([entry]) => {
        const isVisible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', isVisible);
        bar.inert = !isVisible;
      });
      this.stickyObserver.observe(target);
    }
  }

  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
  (() => {
    if (customElements.get('wishlist-grid')) return;

    const CARD_SECTION = 'main-wishlist';
    const FETCH_CONCURRENCY = 6;
    const DEFAULT_LIMIT = 50;

    const whenThemeReady = (callback) => {
      if (window.theme?.wishlist) return callback();
      document.addEventListener('DOMContentLoaded', () => window.theme?.wishlist && callback(), { once: true });
    };

    const fetchCard = async (handle) => {
      try {
        const root = window.theme.routes.root.replace(/\/$/, '');
        const url = `${root}/products/${encodeURIComponent(handle)}?section_id=${CARD_SECTION}`;
        const response = await fetch(url);
        if (!response.ok) return null;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const card = doc.querySelector('[data-wishlist-card]');
        return card ? document.importNode(card, true) : null;
      } catch (error) {
        console.error(error);
        return null;
      }
    };

    const fetchCards = async (handles) => {
      const results = new Array(handles.length).fill(null);
      let cursor = 0;
      const worker = async () => {
        while (cursor < handles.length) {
          const index = cursor++;
          results[index] = await fetchCard(handles[index]);
        }
      };
      await Promise.all(Array.from({ length: Math.min(FETCH_CONCURRENCY, handles.length) }, worker));
      return results.filter(Boolean);
    };

    class WishlistGrid extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-wishlist-grid]');
        this.empty = this.querySelector('[data-wishlist-empty]');
        this.loading = this.querySelector('[data-wishlist-loading]');
        this.count = this.closest('.main-wishlist')?.querySelector('[data-wishlist-count]');
        this.heading = this.closest('.main-wishlist')?.querySelector('h1');
        this.limit = Number(this.dataset.limit) || DEFAULT_LIMIT;
        this.addEventListener('click', this.onClick);
        document.addEventListener('wishlist:updated', this.onUpdated);
        whenThemeReady(() => this.load());
      }

      disconnectedCallback() {
        document.removeEventListener('wishlist:updated', this.onUpdated);
      }

      async load() {
        const handles = window.theme.wishlist.all().slice().reverse().slice(0, this.limit);
        if (!handles.length) {
          this.showEmpty();
          return;
        }
        this.setAttribute('aria-busy', 'true');
        const cards = await fetchCards(handles);
        const saved = new Set(window.theme.wishlist.all());
        this.grid.replaceChildren(...cards.filter((card) => saved.has(card.dataset.handle)));
        this.removeAttribute('aria-busy');
        this.loading.hidden = true;
        this.refreshState();
      }

      onUpdated = (event) => {
        const handles = event.detail?.handles;
        if (!Array.isArray(handles) || this.hasAttribute('aria-busy')) return;
        const hadFocus = this.grid.contains(document.activeElement);
        this.cards().forEach((card) => {
          if (!handles.includes(card.dataset.handle)) card.remove();
        });
        this.refreshState();
        if (hadFocus && !this.grid.contains(document.activeElement)) this.focusFallback();
      };

      onClick = (event) => {
        const button = event.target.closest('[data-wishlist-remove]');
        if (!button || !window.theme?.wishlist) return;
        const card = button.closest('[data-wishlist-card]');
        if (!card) return;
        const sibling = card.nextElementSibling || card.previousElementSibling;
        if (window.theme.wishlist.has(card.dataset.handle)) window.theme.wishlist.toggle(card.dataset.handle);
        card.remove();
        this.refreshState();
        if (this.dataset.removedMessage) window.theme.toast(this.dataset.removedMessage);
        const next = sibling?.querySelector('[data-wishlist-remove]');
        if (next) next.focus();
        else this.focusFallback();
      };

      cards() {
        return Array.from(this.grid.querySelectorAll(':scope > [data-wishlist-card]'));
      }

      refreshState() {
        const total = this.cards().length;
        if (total === 0) {
          this.showEmpty();
          return;
        }
        this.grid.hidden = false;
        this.empty.hidden = true;
        this.setCount(total);
      }

      showEmpty() {
        this.loading.hidden = true;
        this.grid.hidden = true;
        this.empty.hidden = false;
        this.setCount(0);
      }

      setCount(total) {
        if (!this.count) return;
        const template = total === 1 ? this.dataset.countOne : this.dataset.countOther;
        this.count.textContent = total > 0 && template ? template.replace('[count]', String(total)) : '';
      }

      focusFallback() {
        const link = this.empty.hidden ? null : this.querySelector('[data-wishlist-empty-link]');
        (link || this.heading)?.focus();
      }
    }

    customElements.define('wishlist-grid', WishlistGrid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    customElements.define(
      'newsletter-popup',
      class NewsletterPopup extends HTMLElement {
        static STORAGE_KEY = 'hayora:newsletter-popup';
        static DAY_MS = 24 * 60 * 60 * 1000;
        static SUCCESS_CLOSE_DELAY_MS = 4000;

        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;

          this.dialog.addEventListener('click', this.onDialogClick);
          this.dialog.addEventListener('close', this.onClose);

          const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
          if (isDesignMode) {
            document.addEventListener('shopify:section:select', this.onEditorSelect);
            document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
            return;
          }

          const status = this.querySelector('[data-newsletter-status]')?.dataset.newsletterStatus;
          const isOwnSubmission = window.location.hash === `#${this.dataset.formId}`;

          // posted_successfully? is shared by every customer form on the page, so a footer
          // signup also counts as subscribed and must suppress the popup for good.
          if (status === 'success') this.remember('subscribed');

          if (isOwnSubmission && status) {
            this.open();
            if (status === 'success') this.closeTimer = setTimeout(() => this.close(), NewsletterPopup.SUCCESS_CLOSE_DELAY_MS);
            return;
          }

          if (this.isSuppressed()) return;

          const delayMs = Math.max(0, Number(this.dataset.delaySeconds) || 0) * 1000;
          this.openTimer = setTimeout(() => this.open(), delayMs);
        }

        disconnectedCallback() {
          clearTimeout(this.openTimer);
          clearTimeout(this.closeTimer);
          document.removeEventListener('shopify:section:select', this.onEditorSelect);
          document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
        }

        open() {
          if (this.dialog.open || document.querySelector('dialog[open]')) return;
          this.dialog.showModal();
          this.querySelector('[data-newsletter-status] [tabindex="-1"]')?.focus();
        }

        close() {
          if (this.dialog.open) this.dialog.close();
        }

        onDialogClick = (event) => {
          if (event.target === this.dialog || event.target.closest('[data-newsletter-popup-close]')) {
            this.close();
          }
        };

        onClose = () => {
          clearTimeout(this.closeTimer);
          if (window.Shopify && window.Shopify.designMode) return;
          if (this.read()?.state !== 'subscribed') this.remember('dismissed');
        };

        onEditorSelect = (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) this.open();
        };

        onEditorDeselect = (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) this.close();
        };

        isSuppressed() {
          const record = this.read();
          if (!record) return false;
          if (record.state === 'subscribed') return true;
          const dismissMs = Math.max(0, Number(this.dataset.dismissDays) || 0) * NewsletterPopup.DAY_MS;
          return Date.now() - record.at < dismissMs;
        }

        read() {
          try {
            const record = JSON.parse(localStorage.getItem(NewsletterPopup.STORAGE_KEY) || 'null');
            return record && typeof record.at === 'number' ? record : null;
          } catch {
            return null;
          }
        }

        remember(state) {
          try {
            localStorage.setItem(NewsletterPopup.STORAGE_KEY, JSON.stringify({ state, at: Date.now() }));
          } catch {}
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.querySelector('[data-recommendations-content]')) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('product-recommendations [data-recommendations-content]');
        if (content) this.replaceChildren(document.importNode(content, true));
      } catch {}
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view"]) return;
  try {
    
  class QuickViewProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-quick-view-form]');
      this.submitButton = this.querySelector('[data-quick-view-submit]');
      this.notifyToggle = this.querySelector('[data-quick-view-notify-toggle]');
      this.notifyPanel = this.querySelector('[data-quick-view-notify]');
      this.notifyForm = this.querySelector('[data-quick-view-notify-form]');
      this.errorMessage = this.querySelector('[data-quick-view-error]');
      this.idInput = this.querySelector('[data-quick-view-variant-id]');
      this.customWrap = this.querySelector('[data-quick-view-custom]');
      this.customInput = this.querySelector('[data-quick-view-custom-input]');
      this.slideIndex = 0;
      this.variant = null;
      try {
        this.variants = JSON.parse(this.querySelector('[data-quick-view-variants]')?.textContent || '[]');
      } catch {
        this.variants = [];
      }
      this.form?.addEventListener('change', this.onOptionChange);
      this.form?.addEventListener('submit', this.onSubmit);
      this.notifyForm?.addEventListener('submit', this.onNotifySubmit);
      this.addEventListener('click', this.onClick);
      this.refresh();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this.onOptionChange);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.notifyForm?.removeEventListener('submit', this.onNotifySubmit);
      this.removeEventListener('click', this.onClick);
    }

    get fieldsets() {
      return [...this.querySelectorAll('[data-option-index]')];
    }

    get slides() {
      return [...this.querySelectorAll('[data-quick-view-slide]')];
    }

    selectedOptions() {
      return this.fieldsets.map((fieldset) => fieldset.querySelector('input:checked')?.value ?? null);
    }

    matches(variant, options) {
      const custom = this.dataset.customValue;
      return variant.options.every((value, index) => !options[index] || options[index] === custom || value === options[index]);
    }

    resolveVariant(options) {
      if (!this.fieldsets.length) return this.variants.find((variant) => variant.available) || this.variants[0] || null;
      if (options.some((value) => !value)) return null;
      const candidates = this.variants.filter((variant) => this.matches(variant, options));
      if (options.includes(this.dataset.customValue)) return candidates.find((variant) => variant.available) || candidates[0] || null;
      return candidates[0] || null;
    }

    onOptionChange = (event) => {
      if (!event.target.closest('[data-option-index]')) return;
      this.refresh();
    };

    refresh() {
      const options = this.selectedOptions();
      const isCustom = options.includes(this.dataset.customValue);
      const complete = options.every(Boolean);
      const variant = this.resolveVariant(options);
      const changed = variant?.id !== this.variant?.id;
      this.variant = variant;

      if (this.customWrap) {
        this.customWrap.hidden = !isCustom;
        this.customInput.disabled = !isCustom;
      }
      this.updateAvailability(options);
      this.hideError();
      this.idInput.value = variant?.id ?? '';
      if (variant) this.updatePrice(variant);
      if (changed && variant?.featured_media) this.showMedia(variant.featured_media.id);
      this.updateButtons({ complete, variant, isCustom });
      if (changed) this.resetNotify();
    }

    updateButtons({ complete, variant, isCustom }) {
      const button = this.submitButton;
      const soldOut = variant && !variant.available && !isCustom;
      button.hidden = Boolean(soldOut);
      this.notifyToggle.hidden = !soldOut;

      if (!complete) {
        button.disabled = true;
        button.textContent = this.dataset.labelSelect;
      } else if (!variant) {
        button.disabled = true;
        button.textContent = this.dataset.labelUnavailable;
      } else {
        button.disabled = false;
        button.textContent = this.dataset.labelAdd;
      }
    }

    updateAvailability(options) {
      this.fieldsets.forEach((fieldset, optionIndex) => {
        fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
          if (input.value === this.dataset.customValue) return;
          const candidate = options.map((value, index) => (index === optionIndex ? input.value : value));
          const available = this.variants.some((variant) => variant.available && this.matches(variant, candidate));
          input.nextElementSibling?.classList.toggle('quick-view__value--unavailable', !available);
        });
      });
    }

    updatePrice(variant) {
      const price = this.querySelector('[data-quick-view-price] [data-price]');
      if (!price) return;
      const onSale = variant.compare_at_price > variant.price;
      price.classList.toggle('price--on-sale', onSale);
      price.querySelector('[data-price-current]').textContent = window.theme.formatMoney(variant.price);
      const compare = price.querySelector('[data-price-compare]');
      const compareLabel = price.querySelector('[data-price-compare-label]');
      compare.textContent = onSale ? window.theme.formatMoney(variant.compare_at_price) : '';
      compare.hidden = !onSale;
      if (compareLabel) compareLabel.hidden = !onSale;
    }

    showMedia(mediaId) {
      const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index >= 0) this.showSlide(index);
    }

    showSlide(index) {
      const slides = this.slides;
      if (!slides.length) return;
      this.slideIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => slide.classList.toggle('is-active', position === this.slideIndex));
      this.querySelectorAll('[data-quick-view-thumb]').forEach((thumb, position) => {
        if (position === this.slideIndex) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      const counter = this.querySelector('[data-quick-view-counter]');
      if (counter) counter.textContent = String(this.slideIndex + 1);
    }

    onClick = (event) => {
      const step = event.target.closest('[data-quick-view-step]');
      if (step) return this.showSlide(this.slideIndex + Number(step.dataset.quickViewStep));

      const thumb = event.target.closest('[data-quick-view-thumb]');
      if (thumb) return this.showSlide(Number(thumb.dataset.quickViewThumb));

      const quantityStep = event.target.closest('[data-quantity-step]');
      if (quantityStep) return this.stepQuantity(Number(quantityStep.dataset.quantityStep));

      if (event.target.closest('[data-quick-view-notify-toggle]')) this.toggleNotify();
    };

    stepQuantity(delta) {
      const input = this.querySelector('[data-quick-view-quantity]');
      input.value = String(Math.max(1, (parseInt(input.value, 10) || 1) + delta));
    }

    toggleNotify() {
      const open = this.notifyPanel.hidden;
      this.notifyPanel.hidden = !open;
      this.notifyToggle.setAttribute('aria-expanded', String(open));
      if (!open || !this.variant) return;
      const values = this.variant.options.join(' / ');
      const title = `${this.dataset.productTitle} - ${values}`;
      this.notifyForm.querySelector('[data-notify-body]').value = `${this.dataset.notifyPrefix}: ${title} (${this.variant.id})`;
      this.notifyForm.querySelector('[data-notify-variant-id]').value = this.variant.id;
      this.notifyForm.querySelector('input[type="email"]')?.focus();
    }

    resetNotify() {
      if (!this.notifyPanel) return;
      this.notifyPanel.hidden = true;
      this.notifyToggle.setAttribute('aria-expanded', 'false');
      this.notifyForm.hidden = false;
      this.notifyPanel.querySelector('[data-notify-success]').hidden = true;
      this.notifyPanel.querySelector('[data-notify-error]').hidden = true;
    }

    onNotifySubmit = async (event) => {
      event.preventDefault();
      const form = this.notifyForm;
      const submit = form.querySelector('[type="submit"]');
      const error = form.querySelector('[data-notify-error]');
      error.hidden = true;
      submit.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(form.action, { method: 'POST', body: new FormData(form) });
        if (response.url.includes('/challenge')) return form.submit();
        if (!response.ok || !response.url.includes('contact_posted=true')) throw new Error('contact failed');
        form.hidden = true;
        this.notifyPanel.querySelector('[data-notify-success]').hidden = false;
      } catch {
        error.hidden = false;
      } finally {
        submit.removeAttribute('aria-busy');
      }
    };

    showError(message) {
      this.errorMessage.textContent = message;
      this.errorMessage.hidden = false;
    }

    hideError() {
      if (!this.errorMessage) return;
      this.errorMessage.hidden = true;
      this.errorMessage.textContent = '';
    }

    onSubmit = async (event) => {
      event.preventDefault();
      const id = Number(this.idInput?.value);
      if (!id || this.submitButton.disabled) return;
      const customText = this.customInput && !this.customInput.disabled ? this.customInput.value.trim() : null;
      if (customText === '') {
        this.showError(this.dataset.labelCustomRequired);
        this.customInput.focus();
        return;
      }
      const quantity = Math.max(1, parseInt(this.querySelector('[data-quick-view-quantity]')?.value, 10) || 1);
      const item = { id, quantity };
      if (customText) {
        const propertyName = this.customInput.name.replace(/^properties\[(.*)\]$/, '$1');
        item.properties = { [propertyName]: customText };
      }

      this.hideError();
      const label = this.submitButton.textContent;
      this.submitButton.setAttribute('aria-busy', 'true');
      this.submitButton.textContent = this.dataset.labelAdding;
      try {
        await window.theme.cart.add(item);
      } catch (error) {
        this.showError(error.message || window.theme.strings.error);
      } finally {
        this.submitButton.removeAttribute('aria-busy');
        this.submitButton.textContent = label;
      }
    };
  }

  if (!customElements.get('quick-view-product')) customElements.define('quick-view-product', QuickViewProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recent-sales"]) return;
  try {
    
  if (!customElements.get('recent-sales')) {
    const SHOWN_KEY = 'hayora:recent-sales-shown';
    const VISIBLE_MS = 6000;
    const DAY_MS = 86400000;

    const readShown = () => {
      try {
        return JSON.parse(sessionStorage.getItem(SHOWN_KEY)) || [];
      } catch {
        return [];
      }
    };

    const saveShown = (shown) => {
      try {
        sessionStorage.setItem(SHOWN_KEY, JSON.stringify(shown));
      } catch {}
    };

    class RecentSales extends HTMLElement {
      connectedCallback() {
        if (window.Shopify?.designMode) return;
        const maxAge = Number(this.dataset.maxAgeDays) * DAY_MS;
        const sales = JSON.parse(this.querySelector('[data-recent-sales]').textContent);
        const shown = readShown();
        this.queue = sales.filter((sale) => {
          const age = Date.now() - Date.parse(sale.at);
          return age >= 0 && age <= maxAge && !shown.includes(sale.url + sale.at);
        });
        if (!this.queue.length) return;

        this.relative = new Intl.RelativeTimeFormat(this.dataset.locale, { numeric: 'auto' });
        this.querySelector('[data-recent-sales-close]').addEventListener('click', () => this.dismiss());
        this.timer = setTimeout(() => this.showNext(), Number(this.dataset.delay) * 1000);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      // Each sale is shown once per browser session; closing stops the rest of the queue.
      showNext() {
        const sale = this.queue.shift();
        if (!sale) return;
        saveShown([...readShown(), sale.url + sale.at]);

        const whoTemplate = sale.city ? this.querySelector('[data-who-city]') : this.querySelector('[data-who]');
        this.querySelector('[data-recent-sales-who]').textContent = whoTemplate.innerHTML.replace('[city]', sale.city);
        this.querySelector('[data-recent-sales-title]').textContent = sale.title;
        this.querySelector('[data-recent-sales-when]').textContent = this.timeAgo(sale.at);
        this.querySelector('[data-recent-sales-link]').href = sale.url;
        const image = this.querySelector('[data-recent-sales-image]');
        image.src = sale.image || '';
        image.hidden = !sale.image;

        this.hidden = false;
        requestAnimationFrame(() => this.setAttribute('data-visible', ''));
        this.timer = setTimeout(() => this.hide(), VISIBLE_MS);
      }

      hide() {
        this.removeAttribute('data-visible');
        this.timer = setTimeout(() => {
          this.hidden = true;
          this.timer = setTimeout(() => this.showNext(), Number(this.dataset.interval) * 1000);
        }, 400);
      }

      dismiss() {
        clearTimeout(this.timer);
        this.queue = [];
        this.removeAttribute('data-visible');
        setTimeout(() => (this.hidden = true), 400);
      }

      timeAgo(isoDate) {
        const minutes = Math.round((Date.parse(isoDate) - Date.now()) / 60000);
        if (minutes > -60) return this.relative.format(Math.min(minutes, -1), 'minute');
        if (minutes > -1440) return this.relative.format(Math.round(minutes / 60), 'hour');
        return this.relative.format(Math.round(minutes / 1440), 'day');
      }
    }

    customElements.define('recent-sales', RecentSales);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-story')) {
    class ScrollStory extends HTMLElement {
      connectedCallback() {
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      // 0 when the sticky panel pins below the header, 1 when it is about to scroll away.
      update() {
        if (this.reducedMotion.matches) {
          this.style.setProperty('--story-progress', '1');
          return;
        }
        const pinnedTop = parseFloat(getComputedStyle(this.firstElementChild).top) || 0;
        const { top, height } = this.getBoundingClientRect();
        const travel = height - (window.innerHeight - pinnedTop);
        const progress = travel > 0 ? Math.min(Math.max((pinnedTop - top) / travel, 0), 1) : 1;
        this.style.setProperty('--story-progress', progress.toFixed(4));
      }
    }

    customElements.define('scroll-story', ScrollStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slide-in-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('slide-in-banner')) return;

    class SlideInBanner extends HTMLElement {
      static STORAGE_KEY = 'hayora:slide-in-banner';
      static DAY_MS = 24 * 60 * 60 * 1000;
      static RETRY_MS = 1500;
      static EXIT_LEAVE_Y = 10;

      connectedCallback() {
        this.panel = this.querySelector('.slide-in-banner');
        if (!this.panel) return;

        this.armed = false;
        this.panel.addEventListener('click', this.onPanelClick);
        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('cart-drawer:open', this.onOverlayOpen);
        document.addEventListener('cart-notification:open', this.onOverlayOpen);
        document.addEventListener('close', this.onDialogClose, true);
        document.addEventListener('cart:updated', this.onCartUpdated);

        const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
        if (isDesignMode) {
          document.addEventListener('shopify:section:select', this.onEditorSelect);
          document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
          return;
        }

        if (this.isSuppressed()) return;
        this.arm();
      }

      disconnectedCallback() {
        this.disarm();
        clearTimeout(this.retryTimer);
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('cart-drawer:open', this.onOverlayOpen);
        document.removeEventListener('cart-notification:open', this.onOverlayOpen);
        document.removeEventListener('close', this.onDialogClose, true);
        document.removeEventListener('cart:updated', this.onCartUpdated);
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
      }

      /* Trigger handling ------------------------------------------------- */

      arm() {
        let trigger = this.dataset.trigger || 'delay';
        // mouseleave never fires on touch devices, so exit intent falls back to scroll depth.
        if (trigger === 'exit' && window.matchMedia('(hover: none)').matches) trigger = 'scroll';

        this.armed = true;
        if (trigger === 'scroll') {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        } else if (trigger === 'exit') {
          document.documentElement.addEventListener('mouseleave', this.onMouseLeave);
        } else {
          const delayMs = Math.max(0, Number(this.dataset.delaySeconds) || 0) * 1000;
          this.delayTimer = setTimeout(() => this.fire(), delayMs);
        }
      }

      disarm() {
        this.armed = false;
        clearTimeout(this.delayTimer);
        window.removeEventListener('scroll', this.onScroll);
        document.documentElement.removeEventListener('mouseleave', this.onMouseLeave);
      }

      fire() {
        if (!this.armed) return;
        this.disarm();
        this.open();
      }

      onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        const target = Math.min(100, Math.max(0, Number(this.dataset.scrollPercent) || 0));
        const depth = scrollable <= 0 ? 100 : (window.scrollY / scrollable) * 100;
        if (depth >= target) this.fire();
      };

      onMouseLeave = (event) => {
        if (event.clientY <= SlideInBanner.EXIT_LEAVE_Y) this.fire();
      };

      /* Open / close ----------------------------------------------------- */

      get isOpen() {
        return !this.panel.hidden;
      }

      hasCompetingOverlay() {
        return Boolean(document.querySelector('dialog[open]'));
      }

      open() {
        if (this.isOpen) return;
        if (this.hasCompetingOverlay()) {
          this.pending = true;
          return;
        }
        this.pending = false;
        this.panel.hidden = false;
        // Two frames so the initial off-screen position is painted before the transition starts.
        requestAnimationFrame(() => requestAnimationFrame(() => this.panel.classList.add('is-visible')));
      }

      hide() {
        if (!this.isOpen) return;
        this.panel.classList.remove('is-visible');
        this.panel.hidden = true;
      }

      dismiss() {
        this.pending = false;
        this.hide();
        if (window.Shopify && window.Shopify.designMode) return;
        this.remember('dismissed');
      }

      onPanelClick = (event) => {
        if (event.target.closest('[data-slide-in-close]')) this.dismiss();
      };

      onKeydown = (event) => {
        if (event.key !== 'Escape' || !this.isOpen || this.hasCompetingOverlay()) return;
        this.dismiss();
      };

      /* Overlay coordination --------------------------------------------- */

      onOverlayOpen = () => {
        if (!this.isOpen) return;
        this.hide();
        this.pending = true;
      };

      onDialogClose = (event) => {
        if (!(event.target instanceof HTMLDialogElement) || !this.pending) return;
        clearTimeout(this.retryTimer);
        this.retryTimer = setTimeout(() => {
          if (this.pending && !this.isSuppressed()) this.open();
        }, SlideInBanner.RETRY_MS);
      };

      /* Live cart data ---------------------------------------------------- */

      onCartUpdated = (event) => {
        if (this.dataset.mode !== 'free_shipping') return;
        const cart = event.detail?.cart;
        const threshold = Number(this.dataset.threshold) || 0;
        if (!cart || threshold <= 0) return;

        const remaining = threshold - Number(cart.total_price || 0);
        if (remaining <= 0) {
          // Threshold reached: the claim is no longer true, so the banner must go.
          this.pending = false;
          this.disarm();
          this.hide();
          return;
        }
        const textNode = this.querySelector('[data-slide-in-text]');
        if (!textNode || typeof window.theme?.formatMoney !== 'function') return;
        if (cart.item_count > 0) {
          textNode.innerHTML = (this.dataset.remainingHtml || '').replace('[amount]', window.theme.formatMoney(remaining));
        } else {
          textNode.textContent = this.dataset.emptyCart || '';
        }
      };

      /* Theme editor ------------------------------------------------------ */

      onEditorSelect = (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open();
      };

      onEditorDeselect = (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.hide();
      };

      /* Storage ------------------------------------------------------------ */

      isSuppressed() {
        const record = this.read();
        if (!record) return false;
        const dismissMs = Math.max(0, Number(this.dataset.dismissDays) || 0) * SlideInBanner.DAY_MS;
        return Date.now() - record.at < dismissMs;
      }

      read() {
        try {
          const record = JSON.parse(localStorage.getItem(SlideInBanner.STORAGE_KEY) || 'null');
          return record && typeof record.at === 'number' ? record : null;
        } catch {
          return null;
        }
      }

      remember(state) {
        try {
          localStorage.setItem(SlideInBanner.STORAGE_KEY, JSON.stringify({ state, at: Date.now() }));
        } catch {}
      }
    }

    customElements.define('slide-in-banner', SlideInBanner);
  })();

  } catch(e) { console.error(e); }
})();
})();
